import request from '../request'

//退出登录
export function exitlogin(data) {
    return request({
        url: '/api/login/logout',
        method: 'POST',
        data
    })
}

//手机号登录接口
export function mobileLoginApi(data) {
    return request({
        url: '/api/passwordLogin',
        method: 'POST',
        data
    })
}

//获取手机验证码接口
export function mobilesms(data) {
    return request({
        url: '/api/sms',
        method: 'POST',
        data
    })
}

//获取我的账户信息接口
export function userlist(data) {
    return request({
        url: '/api/account/index',
        method: 'GET',
        data
    })
}

//设置工作台密码
export function usergallery(data) {
    return request({
        url: '/web/user/gallery',
        method: 'POST',
        data
    })
}

//工作台密码保存
export function syatempassword(data) {
    return request({
        url: '/web/user/gallery/store',
        method: 'POST',
        data
    })
}

//找回密码-手机号获取
export function getgalleryForgot(data) {
    return request({
        url: '/web/user/get/galleryForgot',
        method: 'GET',
        data
    })
}

//工作台密码找回
export function setgalleryForgot(data) {
    return request({
        url: '/web/user/set/galleryForgot',
        method: 'POST',
        data
    })
}

//在线充值接口
export function payadd(data) {
    return request({
        url: '/web/pay/add',
        method: 'POST',
        data
    })
}

//支付校验接口
export function payispay(data) {
    return request({
        url: '/web/pay/isPay?charge_no=' + data,
        method: 'GET'
    })
}

//对外付款-获取人员名单
export function getuserlist(data) {
    return request({
        url: '/web/project/getUserList',
        method: 'GET',
        params: data
    })
}

//对外付款-提交
export function salaryadd(data) {
    return request({
        url: '/web/salary/add',
        method: 'POST',
        data
    })
}

//对外付款-上传文件
export function salaryuploadFiles(data) {
    return request({
        url: '/web/upload/uploadFiles',
        method: 'POST',
        data
    })
}


//对外收款-人员名单
export function externalgetUserList(data) {
    return request({
        url: '/web/project/external/getUserList',
        method: 'GET',
        params: data
    })
}

//对外收款-提交
export function externaltoadd(data) {
    return request({
        url: '/web/external/toadd',
        method: 'POST',
        data
    })
}

//对外收款-二次确认
export function salarytwoClick(data) {
    return request({
        url: '/web/salary/twoClick',
        method: 'POST',
        data
    })
}

//充值记录
export function dealpaylist(data) {
    return request({
        url: '/web/deal/payList',
        method: 'GET',
        params: data
    })
}

//充值记录-详情
export function dealpayinfo(data) {
    return request({
        url: '/web/deal/payInfo',
        method: 'GET',
        params: data
    })
}

//充值记录-删除
export function dealpaydel(data) {
    return request({
        url: '/web/deal/payDel',
        method: 'POST',
        data
    })
}

//获取项目
export function projectlist(data) {
    return request({
        url: '/web/project/list',
        method: 'GET',
        params: data
    })
}

//付款记录
export function dealsalaryList(data) {
    return request({
        url: '/web/deal/salaryList',
        method: 'GET',
        params: data
    })
}

//付款记录-详情
export function dealsalaryInfo(data) {
    return request({
        url: '/web/deal/salaryInfo',
        method: 'GET',
        params: data
    })
}

//付款记录-删除
export function dealsalaryDel(data) {
    return request({
        url: '/web/deal/salaryDel',
        method: 'POST',
        data
    })
}

//安全中心-账户信息
export function userinfo() {
    return request({
        url: '/api/user/info',
        method: 'GET'
    })
}

//安全中心-系统密码设置
export function syatempasswordset(data) {
    return request({
        url: '/web/user/syatem/password',
        method: 'POST',
        data
    })
}

//安全中心-支付密码设置
export function paypasswordset(data) {
    return request({
        url: '/web/user/pay/password',
        method: 'POST',
        data
    })
}

//粉丝列表
export function fanspeoples() {
    return request({
        url: '/api/follow/fans/list',
        method: 'GET'
    })
}

//我的关注
export function followpeoples() {
    return request({
        url: '/api/follow/list',
        method: 'GET'
    })
}

//推广人员名单
export function extensionpeoples() {
    return request({
        url: '/api/extension/list',
        method: 'GET'
    })
}

//好友列表
export function userpeoples() {
    return request({
        url: '/api/friend/list',
        method: 'GET'
    })
}

//发红包确认付款
export function redpacktoadd(data) {
    return request({
        url: '/web/redpack/toadd',
        method: 'POST',
        data
    })
}

//红包领取
export function redpackdraw(data) {
    return request({
        url: '/web/redpack/draw',
        method: 'POST',
        data
    })
}

//提现申请
export function cashtoadd(data) {
    return request({
        url: '/web/cash/toadd',
        method: 'POST',
        data
    })
}

//提现申请-银行列表
export function cashbanklist() {
    return request({
        url: '/web/cash/bank/list',
        method: 'GET'
    })
}

//红包记录
export function redpackList(data) {
    return request({
        url: '/web/redpack/List',
        method: 'GET',
        params: data
    })
}

//红包详情
export function redpackInfo(data) {
    return request({
        url: '/web/redpack/Info',
        method: 'GET',
        params: data
    })
}

//对外收款-记录
export function dealexternalList(data) {
    return request({
        url: '/web/deal/externalList',
        method: 'GET',
        params: data
    })
}

//对外收款-详情
export function dealexternalInfo(data) {
    return request({
        url: '/web/deal/externalInfo',
        method: 'GET',
        params: data
    })
}

//提现记录
export function dealcashList(data) {
    return request({
        url: '/web/deal/cashList',
        method: 'GET',
        params: data
    })
}

//提现记录-详情
export function dealcashInfo(data) {
    return request({
        url: '/web/deal/cashInfo',
        method: 'GET',
        params: data
    })
}

//数据统计
export function statisticdata() {
    return request({
        url: '/web/statistic/data',
        method: 'GET'
    })
}

//对外付款-模拟用户点击
export function moniadd(data) {
    return request({
        url: '/web/salary/moni/add',
        method: 'POST',
        data
    })
}

//对外收款-模拟用户点击
export function externalmoniadd(data) {
    return request({
        url: '/web/external/moni/add',
        method: 'POST',
        data
    })
}

//城市接口
export function districtslist(data) {
    return request({
        url: '/web/districts/list',
        method: 'GET',
        params: data
    })
}